export const kanban = {
  page: {
    kicker: 'Workspace',
    title: 'Entregables y tablero del equipo',
    subtitle:
      'Planificá la semana, seguí lo que está en vuelo y no perdás de vista los entregables del mes.',
  },
  monthChips: {
    kicker: 'Este mes',
  },
  columns: {
    backlog: 'Backlog',
    thisWeek: 'Esta semana',
    inProgress: 'En progreso',
    inReview: 'En review',
    done: 'Hecho',
    empty: 'Todavía no hay tareas acá',
  },
  priority: {
    low: 'Baja',
    medium: 'Media',
    high: 'Alta',
  },
  quickAdd: {
    cta: 'Agregar tarea',
    placeholder: '¿Qué tiene que pasar?',
    hint: 'Enter para crear · esc para cancelar',
  },
  filters: {
    searchPlaceholder: 'Buscar tareas, tags, descripciones…',
    priority: {
      all: 'Todas las prioridades',
    },
    clear: 'Limpiar filtros',
  },
  drawer: {
    title: 'Editar tarea',
    createdAt: 'Creada {{date}}',
    cancel: 'Cancelar',
    save: 'Guardar',
    delete: 'Eliminar',
    fields: {
      title: 'Título',
      description: 'Descripción',
      status: 'Estado',
      priority: 'Prioridad',
      dueDate: 'Fecha límite',
      tags: 'Tags',
      tagsPlaceholder: 'Separados por coma (blog, seo, …)',
      linkedDeliverable: 'Entregable vinculado',
      linkedDeliverablePlaceholder: 'ej. blog, landing, video',
      assignee: 'Responsable',
    },
  },
} as const
